
/**
 * Encore Foundation - 2.23.0
 * 
 * The contents of this file is owned and generated by the Global Design Systems team.
 * If you require making changes to the values stored here please reach out
 * to #encore on Slack.
 * 
 * Links:
 * 
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 * 
 * Tack!
 * 
 * Global Design Systems
 * encore.spotify.net
 */

/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Aquamarine 180
*/
export const aquamarine = '#9bf0e1';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Aubergine 46
*/
export const aubergine = '#503750';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Azure 135
*/
export const azure = '#509bf5';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Bole 123
*/
export const bole = '#c87d55';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Bright Red 100
*/
export const brightRed = '#e61e32';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Chocolate 75
*/
export const chocolate = '#7d4b32';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Citric 186
*/
export const citric = '#cdf564';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Electric Seafoam 167
*/
export const electricSeafoam = '#19e68c';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Factory Yellow 184
*/
export const factoryYellow = '#fae62d';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Forest 75
*/
export const forest = '#006450';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Pink 100
*/
export const fuchsia = '#dc148c';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Gold 155
*/
export const gold = '#f59b23';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Klein Blue 61
*/
export const kleinBlue = '#4100f5';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Lavender 135
*/
export const lavender = '#b49bc8';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Maroon 55
*/
export const maroon = '#8c1932';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Midnight 35
*/
export const midnight = '#1e3264';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Neon Green 176
*/
export const neonGreen = '#5ff550';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Pumpkin 135
*/
export const orange = '#ff6437';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Rose 180
*/
export const pink = '#ffcdd2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Violet Desat 75
*/
export const plum = '#705378';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Powder Green 185
*/
export const powderGreen = '#c3f0c8';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Royal Blue 55
*/
export const royalBlue = '#2d46b9';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Salmon 135
*/
export const salmon = '#f573a0';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Green Blue 100
*/
export const spearmint = '#27856a';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Storm 155
*/
export const storm = '#a0c3d2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Sunflower 172
*/
export const sunflower = '#ffc864';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Tan 135
*/
export const tan = '#c39687';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Red Orange 100
*/
export const tangerine = '#e3230e';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to Violet 84
*/
export const violet = '#af2896';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, you can achieve similar results with the `bright accent` or `positive` colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const success = '#1db954';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, you can achieve similar results by using the `announcement` colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const announcement = '#2e77d0';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, you can achieve similar results with the `background elevated` colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const info = '#eeeeee';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, you can achieve similar results with the `warning` colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const warning = '#ff5722';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, you can achieve similar results with the `negative` colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const failure = '#e22134';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray7 = '#121212';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray10 = '#181818';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray15 = '#282828';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray20 = '#333333';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray30 = '#535353';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray50 = '#7f7f7f';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray70 = '#b3b3b3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray80 = '#cccccc';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray85 = '#d9d9d9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray90 = '#eeeeee';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gray95 = '#f8f8f8';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to either `gray20` or `gray30`
*/
export const gray25 = '#404040';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to either `gray30` or `gray50`
*/
export const gray40 = '#616161';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to `gray50`
*/
export const gray45 = '#757575';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to either `gray50` or `gray70`
*/
export const gray60 = '#9e9e9e';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated, consider moving to either `gray70` or `gray80`
*/
export const gray75 = '#bdbdbd';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityBlack0 = 'rgba(0, 0, 0, 0)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityBlack10 = 'rgba(0, 0, 0, 0.1)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityBlack30 = 'rgba(0, 0, 0, 0.3)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityBlack50 = 'rgba(0, 0, 0, 0.5)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityBlack60 = 'rgba(0, 0, 0, 0.6)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityBlack70 = 'rgba(0, 0, 0, 0.7)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityBlack90 = 'rgba(0, 0, 0, 0.9)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityWhite0 = 'rgba(255, 255, 255, 0)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityWhite10 = 'rgba(255, 255, 255, 0.1)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityWhite30 = 'rgba(255, 255, 255, 0.3)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityWhite50 = 'rgba(255, 255, 255, 0.5)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityWhite60 = 'rgba(255, 255, 255, 0.6)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityWhite70 = 'rgba(255, 255, 255, 0.7)';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const opacityWhite90 = 'rgba(255, 255, 255, 0.9)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack0`
*/
export const black0 = 'rgba(0, 0, 0, 0)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack10`
*/
export const black10 = 'rgba(0, 0, 0, 0.1)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack30`
*/
export const black30 = 'rgba(0, 0, 0, 0.3)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack50`
*/
export const black50 = 'rgba(0, 0, 0, 0.5)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack60`
*/
export const black60 = 'rgba(0, 0, 0, 0.6)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack70`
*/
export const black70 = 'rgba(0, 0, 0, 0.7)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityBlack90`
*/
export const black90 = 'rgba(0, 0, 0, 0.9)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite0`
*/
export const white0 = 'rgba(255, 255, 255, 0)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite10`
*/
export const white10 = 'rgba(255, 255, 255, 0.1)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite30`
*/
export const white30 = 'rgba(255, 255, 255, 0.3)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite50`
*/
export const white50 = 'rgba(255, 255, 255, 0.5)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite60`
*/
export const white60 = 'rgba(255, 255, 255, 0.6)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite70`
*/
export const white70 = 'rgba(255, 255, 255, 0.7)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite90`
*/
export const white90 = 'rgba(255, 255, 255, 0.9)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to either `opacityBlack10` or `opacityBlack30`
*/
export const black20 = 'rgba(0, 0, 0, 0.2)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to either `opacityBlack30` or `opacityBlack50`
*/
export const black40 = 'rgba(0, 0, 0, 0.4)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to `opacityWhite10`
*/
export const white5 = 'rgba(255, 255, 255, 0.05)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to either `opacityWhite10` or `opacityWhite30`
*/
export const white20 = 'rgba(255, 255, 255, 0.2)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This opacity is deprecated, consider moving to either `opacityWhite30` or `opacityWhite50`
*/
export const white40 = 'rgba(255, 255, 255, 0.4)';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const green = '#1db954';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const greenLight = '#1ed760';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const greenFocus = '#1da64d';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const greenDark = '#14833b';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const black = '#000000';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const white = '#ffffff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const red = '#cd1a2b';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const redLight = '#e22134';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const redDark = '#941320';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const blue = '#2e77d0';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const blueLight = '#4687d6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueFacebook = '#1877f2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const blueDark = '#1d4c85';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This color is deprecated. You can achieve similar results with the warning colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
*/
export const orangeLight = '#ff5722';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const solidBlack0 = '#000000';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const solidWhite200 = '#ffffff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spotifyBlack7 = '#121212';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const midnight35 = '#202F72';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const aubergine46 = '#503659';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const maroon55 = '#8A202B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const royalBlue55 = '#283EA3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const kleinBlue61 = '#4100F4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const forest75 = '#056952';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const chocolate75 = '#834F34';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violet84 = '#B02897';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brightRed100 = '#E91429';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spearmint114 = '#4B917D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const fuchsia115 = '#F036A4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const tangerine120 = '#FF4834';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const bole123 = '#C87D55';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const salmon135 = '#EF77A1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const lavender135 = '#AF93C4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const azure135 = '#59A0F6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pumpkin135 = '#FF7439';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const tan135 = '#C19384';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const storm155 = '#A5BBD1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const gold155 = '#FFA42B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spotifyGreen157 = '#1ED760';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const sunflower172 = '#FFC862';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const rose180 = '#FFD2D7';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const aquamarine180 = '#91EEDA';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const factoryYellow184 = '#FCE54F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const powderGreen185 = '#C5F0C9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const citric186 = '#CFF56A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const neonGreen176 = '#5FF550';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const electricSeafoam167 = '#19E68C';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redOrange25 = '#560F00';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redOrange55 = '#911600';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redOrange75 = '#B71800';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redOrange100 = '#E81B00';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redOrange120 = '#FF4834';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redOrange135 = '#FF7163';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redOrange155 = '#FF9E95';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redOrange180 = '#FFD3CF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brown25 = '#3D2418';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brown55 = '#683E2A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brown75 = '#834F34';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brown100 = '#A96440';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brown123 = '#C87D55';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brown135 = '#D38E67';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brown155 = '#E5AC8A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brown180 = '#F7D7C3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownDesat25 = '#3B251D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownDesat55 = '#653F32';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownDesat75 = '#805040';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownDesat100 = '#A36652';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownDesat135 = '#C19384';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownDesat155 = '#D2B1A6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownDesat180 = '#EADAD5';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const orange25 = '#4F1800';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const orange55 = '#862800';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const orange75 = '#A83200';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const orange100 = '#D64000';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const orange135 = '#FF7439';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const orange155 = '#FFA178';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const orange180 = '#FFD4C2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellow25 = '#491E00';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellow55 = '#793500';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellow75 = '#964400';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellow100 = '#BC5900';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellow135 = '#F47E00';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellow155 = '#FFA42B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellow172 = '#FFC862';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellow180 = '#FFD97E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellowDesat25 = '#39260E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellowDesat55 = '#624218';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellowDesat75 = '#7C531E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellowDesat100 = '#9F6B27';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellowDesat135 = '#D0913F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellowDesat155 = '#DEB076';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const brownYellowDesat180 = '#EFDABF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellow25 = '#352901';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellow55 = '#594602';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellow75 = '#705903';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellow100 = '#8E7203';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellow135 = '#BD9A03';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellow155 = '#DAB503';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellow184 = '#FCE54F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreen25 = '#222E03';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreen55 = '#3B4F05';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreen75 = '#4A6406';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreen100 = '#5F8008';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreen135 = '#80AC0B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreen155 = '#95C90D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreen186 = '#CFF56A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreenDesat25 = '#262D11';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreenDesat55 = '#414D1E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreenDesat75 = '#526226';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreenDesat100 = '#697D30';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreenDesat135 = '#8DA841';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreenDesat155 = '#A9C261';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const yellowGreenDesat180 = '#D7E3B5';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const green25 = '#073116';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const green55 = '#0C5426';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const green75 = '#0F6A2F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const green100 = '#13873C';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const green135 = '#19B551';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const green157 = '#1ED760';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const green180 = '#96F0B6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenDesat25 = '#182F21';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenDesat55 = '#265135';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenDesat75 = '#2D6740';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenDesat100 = '#34854D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenDesat135 = '#3DB35E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenDesat155 = '#5CCE77';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenDesat185 = '#C5F0C9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlue25 = '#013126';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlue55 = '#035341';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlue75 = '#056952';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlue100 = '#088569';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlue135 = '#10B28E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlue155 = '#16D0A6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlue180 = '#91EEDA';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlueDesat25 = '#182E28';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlueDesat55 = '#294F44';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlueDesat75 = '#346557';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlueDesat100 = '#43816F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlueDesat114 = '#4B917D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlueDesat135 = '#5EAC96';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlueDesat155 = '#8BC3B3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const greenBlueDesat180 = '#C9E3DB';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blue25 = '#052A56';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blue55 = '#084791';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blue75 = '#0A59B8';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blue100 = '#0D72EA';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blue135 = '#59A0F6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blue155 = '#89BCF8';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blue180 = '#C8E0FC';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueDesat25 = '#1D2B3A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueDesat55 = '#324B64';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueDesat75 = '#405E7E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueDesat100 = '#5179A1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueDesat135 = '#82A1C0';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueDesat155 = '#A5BBD1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueDesat180 = '#D4DFE9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueViolet25 = '#26008D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueViolet55 = '#3C00E4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueViolet61 = '#4100F4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueViolet75 = '#5925FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueViolet100 = '#7358FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueViolet135 = '#9691FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueViolet155 = '#AFB1FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueViolet180 = '#D7DBFF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueVioletDesat25 = '#1B2658';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueVioletDesat35 = '#202F72';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueVioletDesat55 = '#283EA3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueVioletDesat75 = '#334FCD';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueVioletDesat100 = '#576DD6';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueVioletDesat135 = '#8A9AE3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueVioletDesat155 = '#AAB6EA';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const blueVioletDesat180 = '#D7DCF5';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violet25 = '#400073';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violet55 = '#6900BA';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violet75 = '#8400E7';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violet100 = '#A833FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violet135 = '#C87DFF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violet155 = '#D8A3FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violet180 = '#EDD4FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetDesat25 = '#35243A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetDesat46 = '#503659';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetDesat75 = '#734D85';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetDesat100 = '#8E65A9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetDesat135 = '#AF93C4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetDesat155 = '#C4B1D4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetDesat180 = '#E3DAEB';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPink25 = '#4C1141';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPink55 = '#801D6D';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPink75 = '#A1258A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPink84 = '#B02897';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPink100 = '#CC2FAF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPink135 = '#E079CD';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPink155 = '#E9A1DC';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPink180 = '#F5D3EF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPinkDesat25 = '#3C1C4C';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPinkDesat55 = '#673081';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPinkDesat67 = '#773796';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPinkDesat100 = '#9E57BF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPinkDesat135 = '#BB8DD0';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPinkDesat155 = '#CDADDC';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const violetPinkDesat180 = '#E7D9ED';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pink25 = '#550635';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pink55 = '#8D0B58';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pink75 = '#B00D6E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pink100 = '#DF118B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pink115 = '#F036A4';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pink135 = '#F46EBE';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pink155 = '#F79BD2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pink180 = '#FCD2EB';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pinkDesat25 = '#4C172A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pinkDesat55 = '#871F43';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pinkDesat75 = '#AD2152';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pinkDesat100 = '#DE2666';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pinkDesat135 = '#EF77A1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pinkDesat155 = '#F1A2BC';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const pinkDesat180 = '#F4D6DF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const red25 = '#590810';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const red55 = '#930D1A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const red75 = '#B81021';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const red100 = '#E91429';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const red135 = '#F97481';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const red155 = '#FE9DA7';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const red180 = '#FFD2D7';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redDesat25 = '#521319';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redDesat55 = '#8A202B';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redDesat75 = '#AD2836';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redDesat100 = '#D33F4E';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redDesat135 = '#E2828C';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redDesat155 = '#EAA6AD';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const redDesat180 = '#F5D6D9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const fluorescentRed109 = '#FF001A';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const fluorescentOrange144 = '#FF8B1F';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const fluorescentYellow194 = '#F3FF46';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const fluorescentGreen176 = '#5FF550';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const fluorescentGreenBlue167 = '#19E68C';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const fluorescentCyan185 = '#00FFFF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const fluorescentBlueViolet69 = '#2D28FF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const fluorescentViolet111 = '#C13FFF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const fluorescentPink119 = '#FF1ABF';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiArabicBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiArabicBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiArabicBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiArabicBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiArabicBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiArabicBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiArabicBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiArabicBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiArabicBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiArabicLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiArabicLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiArabicLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiArabicMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiArabicMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiArabicMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiCyrillicBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiCyrillicBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiCyrillicBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiCyrillicBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiCyrillicBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiCyrillicBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiCyrillicBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiCyrillicBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiCyrillicBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiCyrillicLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiCyrillicLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiCyrillicLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiCyrillicMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiCyrillicMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiCyrillicMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiHebrewBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiHebrewBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiHebrewBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiHebrewBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiHebrewBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiHebrewBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiHebrewBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiHebrewBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiHebrewBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiHebrewLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiHebrewLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiHebrewLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiHebrewMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiHebrewMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiHebrewMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinOs2V3BlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinOs2V3BlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinOs2V3BlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinOs2V3BoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinOs2V3BoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinOs2V3BoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinOs2V3BookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.otf';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinOs2V3BookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.woff';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const circularSpotifyUiLatinOs2V3BookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinOs2V3LightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinOs2V3LightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinOs2V3LightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinOs2V3MediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinOs2V3MediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.woff';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularSpotifyUiLatinOs2V3MediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.woff2';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularMonoLatinBookOtf = 'https://encore.scdn.co/1.2.3/Circular-Mono-Latin-Book.otf';
/**
* ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)   
*/
export const circularMonoLatinBookWoff = 'https://encore.scdn.co/1.2.3/Circular-Mono-Latin-Book.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulBlackOtf = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Black.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulBlackWoff = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Black.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulBlackWoff2 = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Black.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulBoldOtf = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Bold.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulBoldWoff = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Bold.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulBoldWoff2 = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Bold.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulLightOtf = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Light.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulLightWoff = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Light.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulLightWoff2 = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Light.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulMediumOtf = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Medium.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulMediumWoff = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Medium.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyHangulMediumWoff2 = 'https://encore.scdn.co/1.2.4/SieulguilSpotify-Hangul-Medium.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulBlackOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulBlackWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulBlackWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulBoldOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulBoldWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulBoldWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulLightOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulLightWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulLightWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.woff2';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulMediumOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.otf';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulMediumWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.woff';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated Brand’s preferred typeface for Hangul script (Korean language). We tested these Sieulguil fonts in product but now prefer to rely on system default Hangul fonts based on user feedback this typeface is too dense and boxy at small sizes to be legible.
*/
export const sieulguilSpotifyLatinHangulMediumWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.woff2';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 100% transparency of an element
*/
export const opacity0 = '0';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 90% transparency of an element
*/
export const opacity10 = '0.1';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 70% transparency of an element
*/
export const opacity30 = '0.3';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 50% transparency of an element
*/
export const opacity50 = '0.5';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 30% transparency of an element
*/
export const opacity70 = '0.7';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
* 10% transparency of an element
*/
export const opacity90 = '0.9';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer4 = '4px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer8 = '8px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer12 = '12px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer16 = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer20 = '20px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer24 = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer32 = '32px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer40 = '40px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer48 = '48px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer56 = '56px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer64 = '64px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer72 = '72px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const spacer80 = '80px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const screenXxsMax = '479px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const screenXsMin = '480px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const screenXsMax = '767px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const screenSmMin = '768px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const screenSmMax = '991px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const screenMdMin = '992px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const screenMdMax = '1199px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const screenLgMin = '1200px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const screenLgMax = '1919px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const screenXlMin = '1920px';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This breakpoint is deprecated, consider moving to either `screenXsMin` or `screenXsMax`
*/
export const screenXs = '480px';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This breakpoint is deprecated, consider moving to either `screenSmMin` or `screenSmMax`
*/
export const screenSm = '768px';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This breakpoint is deprecated, consider moving to either `screenMdMin` or `screenMdMax`
*/
export const screenMd = '992px';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This breakpoint is deprecated, consider moving to either `screenLgMin` or `screenLgMax`
*/
export const screenLg = '1200px';
/**
* ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
* @deprecated This breakpoint is deprecated, consider moving to `screenXlMin`
*/
export const screenXl = '1920px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body1Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body1FontSize = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body1FontWeight = 400;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body1LineHeight = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body1LetterSpacing = '0px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body2Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body2FontSize = '14px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body2FontWeight = 400;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body2LineHeight = '20px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body2LetterSpacing = '0.25px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body3Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body3FontSize = '12px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body3FontWeight = 400;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body3LineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body3LetterSpacing = '0.25px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body4Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body4FontSize = '10px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body4FontWeight = 400;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body4LineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const body4LetterSpacing = '0.25px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta1Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta1FontSize = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta1FontWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta1LineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta1LetterSpacing = '2px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta1Uppercase = 'uppercase';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta2Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta2FontSize = '14px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta2FontWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta2LineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta2LetterSpacing = '1px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta2Uppercase = 'uppercase';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta3Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta3FontSize = '12px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta3FontWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta3LineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta3LetterSpacing = '1px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta3Uppercase = 'uppercase';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta4Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta4FontSize = '10px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta4FontWeight = 700;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta4LineHeight = '16px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta4LetterSpacing = '1px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const cta4Uppercase = 'uppercase';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1FontSize = '96px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1FontWeight = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1LetterSpacing = '-2px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1LineHeight = '104px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1PaddingBottom = '0.67em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1FontSmall = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1FontSizeSmall = '80px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1FontWeightSmall = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1LetterSpacingSmall = '-2px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1LineHeightSmall = '88px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1PaddingBottomSmall = '0.67em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1FontXSmall = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1FontSizeXSmall = '56px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1FontWeightXSmall = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1LetterSpacingXSmall = '-1.75px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1LineHeightXSmall = '64px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display1PaddingBottomXSmall = '0.67em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2FontSize = '80px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2FontWeight = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2LetterSpacing = '-2px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2LineHeight = '88px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2PaddingBottom = '0.67em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2FontSmall = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2FontSizeSmall = '64px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2FontWeightSmall = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2LetterSpacingSmall = '-2px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2LineHeightSmall = '72px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2PaddingBottomSmall = '0.67em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2FontXSmall = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2FontSizeXSmall = '48px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2FontWeightXSmall = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2LetterSpacingXSmall = '-1.75px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2LineHeightXSmall = '56px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const display2PaddingBottomXSmall = '0.67em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1FontSize = '48px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1FontWeight = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1LetterSpacing = '-1px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1LineHeight = '56px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1PaddingBottom = '0.67em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1FontSmall = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1FontSizeSmall = '40px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1FontWeightSmall = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1LetterSpacingSmall = '-1px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1LineHeightSmall = '48px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1PaddingBottomSmall = '0.67em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1FontXSmall = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1FontSizeXSmall = '32px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1FontWeightXSmall = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1LetterSpacingXSmall = '-1px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1LineHeightXSmall = '40px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading1PaddingBottomXSmall = '0.67em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2FontSize = '32px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2FontWeight = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2LetterSpacing = '-0.5px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2LineHeight = '40px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2PaddingBottom = '0.75em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2FontSmall = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2FontSizeSmall = '28px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2FontWeightSmall = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2LetterSpacingSmall = '-0.25px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2LineHeightSmall = '36px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading2PaddingBottomSmall = '0.75em';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading3Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading3FontSize = '24px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading3FontWeight = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading3LineHeight = '32px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading3LetterSpacing = '-0.25px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading3FontSmall = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading3FontSizeSmall = '20px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading3FontWeightSmall = 900;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading3LineHeightSmall = '28px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading3LetterSpacingSmall = '-0.25px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading4Font = 'Circular';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading4FontWeight = 400;
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading4FontSize = '18px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading4LineHeight = '26px';
/**
* ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)   
*/
export const heading4LetterSpacing = '0px';
export const color = {
          aquamarine,
aubergine,
azure,
bole,
brightRed,
chocolate,
citric,
electricSeafoam,
factoryYellow,
forest,
fuchsia,
gold,
kleinBlue,
lavender,
maroon,
midnight,
neonGreen,
orange,
pink,
plum,
powderGreen,
royalBlue,
salmon,
spearmint,
storm,
sunflower,
tan,
tangerine,
violet,
success,
announcement,
info,
warning,
failure,
gray7,
gray10,
gray15,
gray20,
gray30,
gray50,
gray70,
gray80,
gray85,
gray90,
gray95,
gray25,
gray40,
gray45,
gray60,
gray75,
opacityBlack0,
opacityBlack10,
opacityBlack30,
opacityBlack50,
opacityBlack60,
opacityBlack70,
opacityBlack90,
opacityWhite0,
opacityWhite10,
opacityWhite30,
opacityWhite50,
opacityWhite60,
opacityWhite70,
opacityWhite90,
black0,
black10,
black30,
black50,
black60,
black70,
black90,
white0,
white10,
white30,
white50,
white60,
white70,
white90,
black20,
black40,
white5,
white20,
white40,
green,
greenLight,
greenFocus,
greenDark,
black,
white,
red,
redLight,
redDark,
blue,
blueLight,
blueFacebook,
blueDark,
orangeLight,
solidBlack0,
solidWhite200,
spotifyBlack7,
midnight35,
aubergine46,
maroon55,
royalBlue55,
kleinBlue61,
forest75,
chocolate75,
violet84,
brightRed100,
spearmint114,
fuchsia115,
tangerine120,
bole123,
salmon135,
lavender135,
azure135,
pumpkin135,
tan135,
storm155,
gold155,
spotifyGreen157,
sunflower172,
rose180,
aquamarine180,
factoryYellow184,
powderGreen185,
citric186,
neonGreen176,
electricSeafoam167,
redOrange25,
redOrange55,
redOrange75,
redOrange100,
redOrange120,
redOrange135,
redOrange155,
redOrange180,
brown25,
brown55,
brown75,
brown100,
brown123,
brown135,
brown155,
brown180,
brownDesat25,
brownDesat55,
brownDesat75,
brownDesat100,
brownDesat135,
brownDesat155,
brownDesat180,
orange25,
orange55,
orange75,
orange100,
orange135,
orange155,
orange180,
brownYellow25,
brownYellow55,
brownYellow75,
brownYellow100,
brownYellow135,
brownYellow155,
brownYellow172,
brownYellow180,
brownYellowDesat25,
brownYellowDesat55,
brownYellowDesat75,
brownYellowDesat100,
brownYellowDesat135,
brownYellowDesat155,
brownYellowDesat180,
yellow25,
yellow55,
yellow75,
yellow100,
yellow135,
yellow155,
yellow184,
yellowGreen25,
yellowGreen55,
yellowGreen75,
yellowGreen100,
yellowGreen135,
yellowGreen155,
yellowGreen186,
yellowGreenDesat25,
yellowGreenDesat55,
yellowGreenDesat75,
yellowGreenDesat100,
yellowGreenDesat135,
yellowGreenDesat155,
yellowGreenDesat180,
green25,
green55,
green75,
green100,
green135,
green157,
green180,
greenDesat25,
greenDesat55,
greenDesat75,
greenDesat100,
greenDesat135,
greenDesat155,
greenDesat185,
greenBlue25,
greenBlue55,
greenBlue75,
greenBlue100,
greenBlue135,
greenBlue155,
greenBlue180,
greenBlueDesat25,
greenBlueDesat55,
greenBlueDesat75,
greenBlueDesat100,
greenBlueDesat114,
greenBlueDesat135,
greenBlueDesat155,
greenBlueDesat180,
blue25,
blue55,
blue75,
blue100,
blue135,
blue155,
blue180,
blueDesat25,
blueDesat55,
blueDesat75,
blueDesat100,
blueDesat135,
blueDesat155,
blueDesat180,
blueViolet25,
blueViolet55,
blueViolet61,
blueViolet75,
blueViolet100,
blueViolet135,
blueViolet155,
blueViolet180,
blueVioletDesat25,
blueVioletDesat35,
blueVioletDesat55,
blueVioletDesat75,
blueVioletDesat100,
blueVioletDesat135,
blueVioletDesat155,
blueVioletDesat180,
violet25,
violet55,
violet75,
violet100,
violet135,
violet155,
violet180,
violetDesat25,
violetDesat46,
violetDesat75,
violetDesat100,
violetDesat135,
violetDesat155,
violetDesat180,
violetPink25,
violetPink55,
violetPink75,
violetPink84,
violetPink100,
violetPink135,
violetPink155,
violetPink180,
violetPinkDesat25,
violetPinkDesat55,
violetPinkDesat67,
violetPinkDesat100,
violetPinkDesat135,
violetPinkDesat155,
violetPinkDesat180,
pink25,
pink55,
pink75,
pink100,
pink115,
pink135,
pink155,
pink180,
pinkDesat25,
pinkDesat55,
pinkDesat75,
pinkDesat100,
pinkDesat135,
pinkDesat155,
pinkDesat180,
red25,
red55,
red75,
red100,
red135,
red155,
red180,
redDesat25,
redDesat55,
redDesat75,
redDesat100,
redDesat135,
redDesat155,
redDesat180,
fluorescentRed109,
fluorescentOrange144,
fluorescentYellow194,
fluorescentGreen176,
fluorescentGreenBlue167,
fluorescentCyan185,
fluorescentBlueViolet69,
fluorescentViolet111,
fluorescentPink119,
        };
export const cdn = {
          circularSpotifyUiArabicBlackOtf,
circularSpotifyUiArabicBlackWoff,
circularSpotifyUiArabicBlackWoff2,
circularSpotifyUiArabicBoldOtf,
circularSpotifyUiArabicBoldWoff,
circularSpotifyUiArabicBoldWoff2,
circularSpotifyUiArabicBookOtf,
circularSpotifyUiArabicBookWoff,
circularSpotifyUiArabicBookWoff2,
circularSpotifyUiArabicLightOtf,
circularSpotifyUiArabicLightWoff,
circularSpotifyUiArabicLightWoff2,
circularSpotifyUiArabicMediumOtf,
circularSpotifyUiArabicMediumWoff,
circularSpotifyUiArabicMediumWoff2,
circularSpotifyUiCyrillicBlackOtf,
circularSpotifyUiCyrillicBlackWoff,
circularSpotifyUiCyrillicBlackWoff2,
circularSpotifyUiCyrillicBoldOtf,
circularSpotifyUiCyrillicBoldWoff,
circularSpotifyUiCyrillicBoldWoff2,
circularSpotifyUiCyrillicBookOtf,
circularSpotifyUiCyrillicBookWoff,
circularSpotifyUiCyrillicBookWoff2,
circularSpotifyUiCyrillicLightOtf,
circularSpotifyUiCyrillicLightWoff,
circularSpotifyUiCyrillicLightWoff2,
circularSpotifyUiCyrillicMediumOtf,
circularSpotifyUiCyrillicMediumWoff,
circularSpotifyUiCyrillicMediumWoff2,
circularSpotifyUiHebrewBlackOtf,
circularSpotifyUiHebrewBlackWoff,
circularSpotifyUiHebrewBlackWoff2,
circularSpotifyUiHebrewBoldOtf,
circularSpotifyUiHebrewBoldWoff,
circularSpotifyUiHebrewBoldWoff2,
circularSpotifyUiHebrewBookOtf,
circularSpotifyUiHebrewBookWoff,
circularSpotifyUiHebrewBookWoff2,
circularSpotifyUiHebrewLightOtf,
circularSpotifyUiHebrewLightWoff,
circularSpotifyUiHebrewLightWoff2,
circularSpotifyUiHebrewMediumOtf,
circularSpotifyUiHebrewMediumWoff,
circularSpotifyUiHebrewMediumWoff2,
circularSpotifyUiLatinBlackOtf,
circularSpotifyUiLatinBlackWoff,
circularSpotifyUiLatinBlackWoff2,
circularSpotifyUiLatinBoldOtf,
circularSpotifyUiLatinBoldWoff,
circularSpotifyUiLatinBoldWoff2,
circularSpotifyUiLatinBookOtf,
circularSpotifyUiLatinBookWoff,
circularSpotifyUiLatinBookWoff2,
circularSpotifyUiLatinLightOtf,
circularSpotifyUiLatinLightWoff,
circularSpotifyUiLatinLightWoff2,
circularSpotifyUiLatinMediumOtf,
circularSpotifyUiLatinMediumWoff,
circularSpotifyUiLatinMediumWoff2,
circularSpotifyUiLatinOs2V3BlackOtf,
circularSpotifyUiLatinOs2V3BlackWoff,
circularSpotifyUiLatinOs2V3BlackWoff2,
circularSpotifyUiLatinOs2V3BoldOtf,
circularSpotifyUiLatinOs2V3BoldWoff,
circularSpotifyUiLatinOs2V3BoldWoff2,
circularSpotifyUiLatinOs2V3BookOtf,
circularSpotifyUiLatinOs2V3BookWoff,
circularSpotifyUiLatinOs2V3BookWoff2,
circularSpotifyUiLatinOs2V3LightOtf,
circularSpotifyUiLatinOs2V3LightWoff,
circularSpotifyUiLatinOs2V3LightWoff2,
circularSpotifyUiLatinOs2V3MediumOtf,
circularSpotifyUiLatinOs2V3MediumWoff,
circularSpotifyUiLatinOs2V3MediumWoff2,
circularMonoLatinBookOtf,
circularMonoLatinBookWoff,
sieulguilSpotifyHangulBlackOtf,
sieulguilSpotifyHangulBlackWoff,
sieulguilSpotifyHangulBlackWoff2,
sieulguilSpotifyHangulBoldOtf,
sieulguilSpotifyHangulBoldWoff,
sieulguilSpotifyHangulBoldWoff2,
sieulguilSpotifyHangulLightOtf,
sieulguilSpotifyHangulLightWoff,
sieulguilSpotifyHangulLightWoff2,
sieulguilSpotifyHangulMediumOtf,
sieulguilSpotifyHangulMediumWoff,
sieulguilSpotifyHangulMediumWoff2,
sieulguilSpotifyLatinHangulBlackOtf,
sieulguilSpotifyLatinHangulBlackWoff,
sieulguilSpotifyLatinHangulBlackWoff2,
sieulguilSpotifyLatinHangulBoldOtf,
sieulguilSpotifyLatinHangulBoldWoff,
sieulguilSpotifyLatinHangulBoldWoff2,
sieulguilSpotifyLatinHangulLightOtf,
sieulguilSpotifyLatinHangulLightWoff,
sieulguilSpotifyLatinHangulLightWoff2,
sieulguilSpotifyLatinHangulMediumOtf,
sieulguilSpotifyLatinHangulMediumWoff,
sieulguilSpotifyLatinHangulMediumWoff2,
        };
export const opacity = {
          opacity0,
opacity10,
opacity30,
opacity50,
opacity70,
opacity90,
        };
export const spacer = {
          spacer4,
spacer8,
spacer12,
spacer16,
spacer20,
spacer24,
spacer32,
spacer40,
spacer48,
spacer56,
spacer64,
spacer72,
spacer80,
        };
export const breakpoint = {
          screenXxsMax,
screenXsMin,
screenXsMax,
screenSmMin,
screenSmMax,
screenMdMin,
screenMdMax,
screenLgMin,
screenLgMax,
screenXlMin,
screenXs,
screenSm,
screenMd,
screenLg,
screenXl,
        };
export const type = {
          body1Font,
body1FontSize,
body1FontWeight,
body1LineHeight,
body1LetterSpacing,
body2Font,
body2FontSize,
body2FontWeight,
body2LineHeight,
body2LetterSpacing,
body3Font,
body3FontSize,
body3FontWeight,
body3LineHeight,
body3LetterSpacing,
body4Font,
body4FontSize,
body4FontWeight,
body4LineHeight,
body4LetterSpacing,
cta1Font,
cta1FontSize,
cta1FontWeight,
cta1LineHeight,
cta1LetterSpacing,
cta1Uppercase,
cta2Font,
cta2FontSize,
cta2FontWeight,
cta2LineHeight,
cta2LetterSpacing,
cta2Uppercase,
cta3Font,
cta3FontSize,
cta3FontWeight,
cta3LineHeight,
cta3LetterSpacing,
cta3Uppercase,
cta4Font,
cta4FontSize,
cta4FontWeight,
cta4LineHeight,
cta4LetterSpacing,
cta4Uppercase,
display1Font,
display1FontSize,
display1FontWeight,
display1LetterSpacing,
display1LineHeight,
display1PaddingBottom,
display1FontSmall,
display1FontSizeSmall,
display1FontWeightSmall,
display1LetterSpacingSmall,
display1LineHeightSmall,
display1PaddingBottomSmall,
display1FontXSmall,
display1FontSizeXSmall,
display1FontWeightXSmall,
display1LetterSpacingXSmall,
display1LineHeightXSmall,
display1PaddingBottomXSmall,
display2Font,
display2FontSize,
display2FontWeight,
display2LetterSpacing,
display2LineHeight,
display2PaddingBottom,
display2FontSmall,
display2FontSizeSmall,
display2FontWeightSmall,
display2LetterSpacingSmall,
display2LineHeightSmall,
display2PaddingBottomSmall,
display2FontXSmall,
display2FontSizeXSmall,
display2FontWeightXSmall,
display2LetterSpacingXSmall,
display2LineHeightXSmall,
display2PaddingBottomXSmall,
heading1Font,
heading1FontSize,
heading1FontWeight,
heading1LetterSpacing,
heading1LineHeight,
heading1PaddingBottom,
heading1FontSmall,
heading1FontSizeSmall,
heading1FontWeightSmall,
heading1LetterSpacingSmall,
heading1LineHeightSmall,
heading1PaddingBottomSmall,
heading1FontXSmall,
heading1FontSizeXSmall,
heading1FontWeightXSmall,
heading1LetterSpacingXSmall,
heading1LineHeightXSmall,
heading1PaddingBottomXSmall,
heading2Font,
heading2FontSize,
heading2FontWeight,
heading2LetterSpacing,
heading2LineHeight,
heading2PaddingBottom,
heading2FontSmall,
heading2FontSizeSmall,
heading2FontWeightSmall,
heading2LetterSpacingSmall,
heading2LineHeightSmall,
heading2PaddingBottomSmall,
heading3Font,
heading3FontSize,
heading3FontWeight,
heading3LineHeight,
heading3LetterSpacing,
heading3FontSmall,
heading3FontSizeSmall,
heading3FontWeightSmall,
heading3LineHeightSmall,
heading3LetterSpacingSmall,
heading4Font,
heading4FontWeight,
heading4FontSize,
heading4LineHeight,
heading4LetterSpacing,
        };
export const body1 = {
  fontSize: body1FontSize,
  fontWeight: body1FontWeight,
  lineHeight: body1LineHeight,
  letterSpacing: body1LetterSpacing,
};
export const body2 = {
  fontSize: body2FontSize,
  fontWeight: body2FontWeight,
  lineHeight: body2LineHeight,
  letterSpacing: body2LetterSpacing,
};
export const body3 = {
  fontSize: body3FontSize,
  fontWeight: body3FontWeight,
  lineHeight: body3LineHeight,
  letterSpacing: body3LetterSpacing,
};
export const body4 = {
  fontSize: body4FontSize,
  fontWeight: body4FontWeight,
  lineHeight: body4LineHeight,
  letterSpacing: body4LetterSpacing,
};
export const cta1 = {
  fontSize: cta1FontSize,
  fontWeight: cta1FontWeight,
  lineHeight: cta1LineHeight,
  letterSpacing: cta1LetterSpacing,
  textTransform: cta1Uppercase,
};
export const cta2 = {
  fontSize: cta2FontSize,
  fontWeight: cta2FontWeight,
  lineHeight: cta2LineHeight,
  letterSpacing: cta2LetterSpacing,
  textTransform: cta2Uppercase,
};
export const cta3 = {
  fontSize: cta3FontSize,
  fontWeight: cta3FontWeight,
  lineHeight: cta3LineHeight,
  letterSpacing: cta3LetterSpacing,
  textTransform: cta3Uppercase,
};
export const cta4 = {
  fontSize: cta4FontSize,
  fontWeight: cta4FontWeight,
  lineHeight: cta4LineHeight,
  letterSpacing: cta4LetterSpacing,
  textTransform: cta4Uppercase,
};
export const display1 = {
  fontSize: display1FontSize,
  fontWeight: display1FontWeight,
  letterSpacing: display1LetterSpacing,
  lineHeight: display1LineHeight,
  paddingBottom: display1PaddingBottom,
};
export const display2 = {
  fontSize: display2FontSize,
  fontWeight: display2FontWeight,
  letterSpacing: display2LetterSpacing,
  lineHeight: display2LineHeight,
  paddingBottom: display2PaddingBottom,
};
export const heading1 = {
  fontSize: heading1FontSize,
  fontWeight: heading1FontWeight,
  letterSpacing: heading1LetterSpacing,
  lineHeight: heading1LineHeight,
  paddingBottom: heading1PaddingBottom,
};
export const heading2 = {
  fontSize: heading2FontSize,
  fontWeight: heading2FontWeight,
  letterSpacing: heading2LetterSpacing,
  lineHeight: heading2LineHeight,
  paddingBottom: heading2PaddingBottom,
};
export const heading3 = {
  fontSize: heading3FontSize,
  fontWeight: heading3FontWeight,
  lineHeight: heading3LineHeight,
  letterSpacing: heading3LetterSpacing,
};
export const heading4 = {
  fontWeight: heading4FontWeight,
  fontSize: heading4FontSize,
  lineHeight: heading4LineHeight,
  letterSpacing: heading4LetterSpacing,
};